import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { newsRPMNetworkCollection } from "#root/schema/platform/newsrpm-marketplace";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Networks{" "}
    <Link className="button" to="/admin/platform/newsrpm-marketplace/network/new">
      New Network
    </Link>
  </Fragment>
);

export default function NwtworkPage(): ReactNode {
  return (
    <PageLayout title="NewsRPM Marketplace - Network">
      <PaginatedList title={title} collection={newsRPMNetworkCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Network Code</th>
              <th>Network Name</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ code, name }) => (
              <tr key={code}>
                <td>{code}</td>
                <td>{name}</td>
                <td>
                  <Link to={`/admin/platform/newsrpm-marketplace/network/${code}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
